// MUI imports
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";

export const GenericListHeader = ({ heading }) => {
  return (
    <Stack
      direction="row"
      spacing={2}
      sx={{
        justifyContent: "space-between",
        alignItems: "center",
        pb: 1,
      }}
    >
      <Typography variant="h5">{heading}</Typography>
      <Stack direction="row" spacing={2}></Stack>
    </Stack>
  );
};
